// packages/crm-app/src/components/AdditionalInfoModal.tsx
import React from "react";

interface Lead {
  fullName: string;
  interestedIn?: string;
  city?: string;
  profileStatus?: string;
  linkedIn?: string;
  addressLine1?: string;
  addressLine2?: string;
  landmark?: string;
  pincode?: string;
  state?: string;
  referredBy?: string;
  investmentType?: string;
  annualIncome?: string;
  budget?: string;
  occupationType?: string;
  incomeSource?: string;
  familySize?: string;
}

interface AdditionalInfoModalProps {
  lead: Lead;
  onClose: () => void;
}

export const AdditionalInfoModal: React.FC<AdditionalInfoModalProps> = ({
  lead,
  onClose,
}) => {
  console.log("interestedIn", lead.interestedIn);

  const interestedInLabels: Record<string, string> = {
    layout_gated_community: "Layout in Gated Community",
    farmland: "Farmland",
    villa_gated_community: "Villa in Gated Community",
    apartment: "Apartment",
  };

  const formatInterestedIn = (value: string): string => {
    if (!value) return "N/A";
    return value
      .split(", ")
      .map((v) => interestedInLabels[v.trim()] || v)
      .join(", ");
  };

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-gray-800 text-white rounded-lg p-6 max-w-6xl w-full h-[70vh] mx-4 overflow-y-auto scrollbar-hide"
      >
        <h2 className="text-xl mb-6">Additional Information</h2>

        <div className="grid grid-cols-3 gap-4 ">
          <div>
            <label className="block text-gray-400 mb-2">Interested in</label>
            <div className="bg-gray-700 p-3 rounded">
              {formatInterestedIn(lead.interestedIn || "")}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">City</label>
            <div className="bg-gray-700 p-3 rounded">{lead.city || "N/A"}</div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Profile Status</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.profileStatus || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">
              LinkedIn Profile (If Applicable)
            </label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.linkedIn || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Address Line 1</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.addressLine1 || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Address Line 2</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.addressLine2 || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Landmark</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.landmark || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Pincode</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.pincode || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">State</label>
            <div className="bg-gray-700 p-3 rounded">{lead.state || "N/A"}</div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">
              Referred By Mobile Number
            </label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.referredBy || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Investment Type</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.investmentType || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">
              Annual Income in INR (Optional)
            </label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.annualIncome || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Budget in INR</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.budget || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Occupation Type</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.occupationType || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Income Source</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.incomeSource || "N/A"}
            </div>
          </div>
          <div>
            <label className="block text-gray-400 mb-2">Family Size</label>
            <div className="bg-gray-700 p-3 rounded">
              {lead.familySize || "N/A"}
            </div>
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-6 bg-green-600 px-6 py-2 rounded"
        >
          Close
        </button>
      </div>
    </div>
  );
};
